import React from 'react'

import clsx from 'clsx'

import Link from 'components/Link'
import UnorderedItem from 'components/UnorderedItem'
import { useEventContext } from 'context/EventContext'

import classes from './Categories.module.scss'

/** @type {import("./types").default} */
const Categories = ({ categories = [] }) => {
  const { addEvent } = useEventContext({})

  return (
    <ul
      data-testid="listing-item_categories"
      className={clsx('Categories', classes.details, { [classes.detailsEvenCategories]: categories.length % 2 === 0 })}
    >
      {categories.map(category => (
        <UnorderedItem key={category.name}>
          <Link
            href={category.url}
            {...addEvent({
              engagementComponent: 'product_card-item',
              engagementDestination: 'go-to_category_all-products',
              engagementDetails: `text-link_category-name`,
              name: 'engagement_product_click',
            })}
            variant="body-xs"
          >
            {category.name}
          </Link>
        </UnorderedItem>
      ))}
    </ul>
  )
}

export default Categories
